import * as React from "react";
const Location = (props) => (
    <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M17.184 7.042c-.875-3.85-4.233-5.583-7.183-5.583h-.009c-2.941 0-6.308 1.725-7.183 5.575-.975 4.3 1.658 7.941 4.042 10.233A4.53 4.53 0 0 0 10 18.542a4.5 4.5 0 0 0 3.142-1.275c2.383-2.292 5.016-5.925 4.041-10.225M10 11.217a2.625 2.625 0 1 1 0-5.25 2.625 2.625 0 0 1 0 5.25"
            fill={props.color || "#009CA6"}
        />
    </svg>
);
export default Location;
